import { i18n, DEFAULT_LANG } from '@/services/i18n'
import axios from 'axios'
import browserLocale from 'browser-locale'

export default {
  state: {
    loadedLanguages: [DEFAULT_LANG],
    preferredLanguage: DEFAULT_LANG
  },
  actions: {
    initI18nLanguage (ctx) {
      const locale = ctx.state.preferredLanguage || window.localStorage.getItem('locale') || browserLocale() || DEFAULT_LANG
      ctx.dispatch('loadLanguage', locale)
    },
    setI18nLanguage (ctx, lang) {
      window.localStorage.setItem('locale', lang)
      i18n.locale = lang
      axios.defaults.headers.common['Accept-Language'] = lang
      ctx.state.preferredLanguage = lang
      document.documentElement.lang = lang
    },
    async loadLanguage ({ state, dispatch, commit }, lang) {
      if (i18n.locale !== lang) {
        if (!state.loadedLanguages.includes(lang)) {          
          try {          
            const msgs = await import(`@/lang/${lang}/translations.yml`)           
            i18n.setLocaleMessage(lang, msgs[lang])
            commit('populateLoadedLanguages', lang)
          } catch (e) {
            console.warn(`No translation file for '${lang}' was found. Translations will fall back to ${DEFAULT_LANG}`)
          }
        }
        dispatch('setI18nLanguage', lang)
      }
    },
    setPreferredLanguage (ctx, lang) {
      ctx.commit('setPreferredLanguage', lang)
    }
  },
  mutations: {
    populateLoadedLanguages (state, lang) {
      state.loadedLanguages.push(lang)
    },
    setPreferredLanguage (state, lang) {
      state.preferredLanguage = lang
    }
  },
  getters: {
    preferredLanguage (state) {
      return state.preferredLanguage
    }
  }
}
